<template>
    <div class="zhuanshudingding">
        <div class="banner"></div>
        <div class="cont1">
            <div class="box-cont1">
                <p class="title-box">数字智能工厂面临的三大挑战</p>
                <!-- <p class="con-box">如何既能快速打造数字化办公运营平台满足业务发展需要，又能保障信息安全及业务生态之间的完美融合</p> -->
                <ul class="ul-box">
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/1af902c6-2696-425a-ad82-05e09ea81b79.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="pp1">订单过程难管控</p>
                        <p class="pp2">销售员报价信息无管控，订单合同同步不及</p>
                        <p class="pp2">时，订单进度无法实时查询</p>
                    </li>
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/8aae7c88-e296-4835-9b99-e77267c26f46.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="pp1">库存数量不准确</p>
                        <p class="pp2">纸质统计容易遗漏，同步不及时， 库存数据</p>
                        <p class="pp2">不准确，订单发货无法实时统计</p>
                    </li>
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/e79ef48e-ad43-40fe-b54d-9fdfd542cc94.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="pp1">账款管理混乱</p>
                        <p class="pp2">无账款账期管理，应收款项无提醒，容易遗</p>
                        <p class="pp2">忘导致漏收等</p>
                    </li>
                </ul>
            </div>
            <div class="box2-cont1">
                <p class="miderTitle">数字智能工厂实现价值</p>
                <div class="line"></div>
                <p class="letter-title">实现知识经验沉淀和共享，以及企业高效运营管理</p>
                <ul class="box2-ul">
                    <li>
                        <p class="ps1">老板/厂长</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">生产运营指标可视化呈现</p>
                    </li>
                    <li>
                        <p class="ps1">销售人员</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">生产全过程数据实时查看</p>
                    </li>
                    <li>
                        <p class="ps1">仓库</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">生产，入库，销售实时管理</p>
                    </li>
                </ul>
                
            </div>
        </div>
        <div class="cont2">
            <p class="miderTitles">推荐功能</p>
            <ul class="tuijian">
                <li>
                    <div class="top-hexin">
                        <img src="http://img601.yun300.cn/repository/image/e6233567-ae89-437c-a54c-741a64db2e52.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="title-hexin">从「项目」开始</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">「项目」是 Teambition 的基本协作单元，你可以为部门事务、重要事项或者交付项目等等</p>
                        <p class="p-hexin">创建一个「项目」。</p>
                    </div>
                </li>
                <li>
                    <div class="top-hexin">
                        <img src="http://img601.yun300.cn/repository/image/7818eef9-d969-4ce0-afd7-5e593d48124a.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="title-hexin">任务</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">承载任务相关所有信息 减少信息在沟通过程中的失真，场景化沟通，更加透明高效。</p>
                    </div>
                </li>
                <!--  -->
                <li>
                    <div class="top-hexin">
                        <img src="http://img601.yun300.cn/repository/image/7818eef9-d969-4ce0-afd7-5e593d48124a.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="title-hexin">任务</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">承载任务相关所有信息 减少信息在沟通过程中的失真，场景化沟通，更加透明高效。</p>
                    </div>
                </li>
                <li>
                    <div class="top-hexin">
                        <img src="http://img601.yun300.cn/repository/image/da170edc-b874-40dc-9763-f6f97575f709.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="title-hexin">分享</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">可以将项目推进过程中重要的信息和知识分享、通告一键分享给团队所有成员，并与成员进</p>
                        <p class="p-hexin">行互相讨论。</p>
                    </div>
                </li>
                <li>
                    <div class="top-hexin">
                        <img src="http://img601.yun300.cn/repository/image/7818eef9-d969-4ce0-afd7-5e593d48124a.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="title-hexin">文件</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">随时随地访问文件库、发表看法 无需在海量群聊中寻找</p>
                    </div>
                </li>
                <li>
                    <div class="top-hexin">
                        <img src="http://img601.yun300.cn/repository/image/7818eef9-d969-4ce0-afd7-5e593d48124a.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="title-hexin">日程</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">可以跨项目查看自己和他人的任务和日程安排，轻松规划每一天。</p>
                    </div>
                </li>
                
            </ul>
            <div class="sssdd"></div>
        </div>

        <div class="cont3s">
            <div class="zhuanjia">
                <p class="bushuzhuanjia">部署专家免费服务</p>
                <p class="zhuanjiafuwu"><span>联系部署专家：</span>根据您提交的需求，将有钉钉部署专家免费为您服务！</p>
                <div class="btn-zixun" @click="jumpZX">立即咨询</div>
            </div>
            <div class="sssdd"></div>
        </div>
    </div>
</template>
        
<script>
export default {
   methods: {
       jumpZX(){
                   window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')

       }
   }
}
</script>
<style lang='less' scoped>
.zhuanshudingding{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url("http://img601.yun300.cn/repository/image/8908a9a9-edf6-4a3c-acae-08f259ff72ae.jpg?tenantId=214689&viewType=1&k=1651226704000");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
    }
    .cont1{
        width: 100%;
        .box-cont1{
            width: 60%;
            height:488px ;
            margin: 40px auto;
            background-color: rgba(255, 255, 255, 1);
           box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
            border-radius: 6px;
            padding: 40px 90px;
            padding-bottom: 20px;
            .title-box{
                font-size: 30px;
                color: #000;
                line-height: 40px;
                letter-spacing: 2px;
            }
            .con-box{
                font-size: 20px;
                line-height: 25px;
                color:#696969;
                margin-top: 20px;
            }
            .ul-box{
                width: 100%;
                height: 330px;
                margin-top: 23px;
                display: flex;
                justify-content: space-between;
                li{
                    width: 400px;
                    text-align: center;
                    img{
                        width: 100%;
                        height: 188px;
                        
                    }
                    .pp1{
                        font-size:24px;
                        color:#000000;
                        text-align: center;
                        line-height: 45px;
                        font-weight: bold;
                        letter-spacing: 2px;
                        margin-top: 10px;
                    }
                    .pp2{
                        font-size:18px;
                        color:#808080;
                        text-align: center;
                        line-height: 30px;
                    }
                }
            }
        }
        .box2-cont1{
            width: 100%;
            .box2-ul{
                width: 60%;
                margin: 50px auto;
                display: flex;
                justify-content: space-between;
                li{
                    width: 453px;
                    height: 180px;
                    background-image: url("https://img.alicdn.com/tfs/TB15Q3KDhD1gK0jSZFKXXcJrVXa-370-184.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    padding-top: 25px;
                    .ps1{
                        font-size: 25px;
                        font-weight: 100;
                        color: #fff;
                        text-align: center;
                        line-height: 40px;
                    }
                    .lin-yuanjiao{
                        width: 50px;
                        height: 3px;
                        border-radius: 6px;
                        background-color: #fff;
                        margin: 0 auto;
                        margin-bottom: 22px;
                        margin-top: 3px;
                    }
                    .ps2{
                        font-size: 18px;
                        color:#FFFFFF;
                        line-height: 26px;
                        text-align: center;
                        letter-spacing: 1px;
                        margin-top: 5px;
                    }
                }
            }
        }
        
    }
    .cont2{
        width: 100%;
        background-color: #F7F7F7;
        .miderTitles{
            font-size: 35px;
            text-align: center;
            color: #000;
            line-height: 130px;
        }
        .tuijian{
            width: 66%;
            margin: auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            li{
                width: 30%;
                height: 280px;
                background-color: #fff;
                transition: all 0.3s linear;
                margin-bottom: 40px;
                .top-hexin{
                    width: 100%;
                    height: 150px;
                    background-color: rgba(237, 240, 246, 1);
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 60px;
                        height: 45px;
                        margin-top: 10px;
                    }
                    .title-hexin{
                        font-size: 20px;
                        color: #000;
                        line-height: 36px;
                        text-align: center;
                        margin-top: 15px;
                    }

                }
                .bottom-hexin{
                    width: 100%;
                    height: 130px;
                    background-color: #fff;
                    padding-top: 20px;
                    .p-hexin{
                        font-size: 19px;
                        line-height: 28px;
                        color:#696969;
                        text-align: center;
                    }
                }
            }
            li:hover{
                box-shadow: 0px 0px 20px 15px rgb(0 0 0 / 10%);
            }
            
        }
        
        .sssdd{
            height: 40px;
        }
    }
}
.miderTitle{
    font-size: 35px;
    text-align: center;
    color: #000;
    line-height: 50px;
}
.line{
   width: 40px;
    height: 2px;
    background-color: rgba(0, 137, 255, 1);
    margin: 0 auto;
    margin-top: 12px;
 }
 .letter-title{
    font-size: 21px;
    text-align: center;
   color: #000;
    line-height: 30px;
     margin-top: 15px;
}
.cont3s{
    width: 100%;
    background-color: #fff!important;
    .miderTitles{
            font-size: 30px;
            text-align: center;
            color: #000;
            line-height: 130px;
    }
    .tuijian{
            width: 66%;
            margin: auto;
            overflow: hidden;
            li{
                width: 233px;
                height: 168px;
                background-color: rgba(245, 245, 245, 1);
                transition: all 0.3s linear;
                float: left;
                margin-right: 14px;
                margin-bottom: 20px;
                text-align: center;
                img{
                    width: 70px;
                    height: 70px;
                    margin-top: 20px;
                }
                .lianlutitle{
                    font-size: 18px;
                    color: #000;
                    text-align: center;

                }
            }
    }
    .zhuanjia{
            width: 66%;
            height: 150px;
             background-color: rgba(245, 245, 245, 1);
            margin: auto;
            padding-left: 50px;
            padding-top: 45px;
            position: relative;
            margin-top: 50px;
            .bushuzhuanjia{
                font-size: 24px;
                color:#000000;
                font-weight: bold;
            }
            .zhuanjiafuwu{
                color:#696969;
                font-size: 19px;
                margin-top: 10px;
                span{
                    color:#0089ff;
                }
            }
            .btn-zixun{
                width: 150px;
                height: 50px;
                text-align: center;
                line-height: 50px;
                color: #fff;
                background-color: rgba(0, 137, 255, 1);
                position: absolute;
                right: 50px;
                top: 50px;
                border-radius: 4px;
                cursor: pointer;
            }
        }
        .sssdd{
            height: 40px;
        }
}
</style>